import React from 'react'

function Loader({style}) {
    return (
        <div className='sv-custom-loader' style={style}>
            <img src='/assets/images/loader.svg' />
        </div>
    )
}

export default Loader
